export default __webpack_public_path__ + "static/media/easyidentity.f2313b61.jpg";